import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import {
  faArrowUpRightFromSquare,
  faBook,
} from '@fortawesome/pro-regular-svg-icons';

interface Publication {
  url: string;
  description: string;
}

const PublicationItem = ({ publication }: { publication: Publication }) => {
  // Extract domain from URL for display
  const getDomain = (url: string) => {
    try {
      const domain = new URL(url).hostname.replace('www.', '');
      return domain;
    } catch {
      return url;
    }
  };

  const handleKeyPress = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      window.open(publication.url, '_blank');
    }
  };

  return (
    <div
      role="article"
      tabIndex={0}
      onKeyDown={handleKeyPress}
      className="group flex py-2 items-center transition-all duration-200 border-b border-neutral-100 last:border-b-0"
    >
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-2 text-xs text-neutral-500">
          <Icon icon={faBook} />
          <span>{getDomain(publication.url)}</span>
        </div>
        <p className="text-sm font-medium text-neutral-600 line-clamp-2 ">
          {publication.description}
        </p>
        <div className="flex items-center">
          <button
            onClick={() => window.open(publication.url, '_blank')}
            className="text-link text-xs font-semibold hover:text-sky-500 transition-colors duration-200 flex items-center gap-2"
            aria-label="Open publication in new tab"
          >
            Read more
            <Icon icon={faArrowUpRightFromSquare} className="h-3 w-3" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PublicationItem;
